import { PaymentVm } from '../classes/paymentVm';
import { AppResponse } from 'modules/core/interfaces/appResponse';
import AuthorizedApiClient from 'modules/auth/models/authorizedApiClient';
import { AxiosResponse } from 'axios';
import store from '@/store/index';
import { PaymentHistoryVm } from '../classes/paymentHistoryVm';

export class InvoicesApi {
  public MasterAccountId: string;

  public constructor() {
    this.MasterAccountId = store.state.auth && store.state.auth.user
    ? store.state.auth.user.MasterAccountId
    : null;
  }

  public async getPaymentsHistory(
    pageNumber: number,
    pageSize: number,
    isDescending: boolean,
    orderBy: string,
  ): Promise<PaymentHistoryVm> {
    const response: AxiosResponse<
      AppResponse<PaymentVm[]>
    > = await AuthorizedApiClient.get(
      '/payment/GetPaymentHistory?masterAccountId=' + this.MasterAccountId
      + '&pageNumber=' + pageNumber
      + '&pageSize=' + pageSize
      + '&IsDescending=' + isDescending
      + '&orderBy=' + orderBy,
    );

    const appResponse: AppResponse<PaymentVm[]> = response.data;
    if (appResponse.IsSuccess) {
      const totalCount: number = (JSON.parse(response.headers['lc-pagination'])).TotalCount;
      const returnData: PaymentHistoryVm = {
        payments: appResponse.Result,
        totalCount,
      };
      return returnData;
    } else {
      throw new Error(appResponse.ErrorCodes.join(','));
    }
  }
}
